import _ from 'lodash';
import { bindCallbacks, statusText } from 'scripts/infrastructure/backends/fake_backend_http/lib/common';

export default class WebhookService {
  constructor(database, pubsub) {
    this._pubsub = pubsub;
    this.getDatabase = database;
  }

  fetchAll(attrs, callback, path) {
    let webhooks = this._getWebhooks('sagan---');
    callback(null, { status: 200, statusText: statusText(200), response: webhooks || [] });
  }

  add(attrs, callback, path, webhook) {
    this.getDatabase('sagan---').webhooks.push(attrs);
    callback(null, { status: 201, statusText: statusText(201) });
  }

  delete(attrs, callback, path, { webhookId }) {
    let webhook = _.find(this._getWebhooks('sagan---'), { id: webhookId });
    if (webhook.enabled) {
      let errorResponse = {
        status: 400,
        statusText: statusText(400),
        data: {
          errors: [{ code: 'invalid_state', detail: 'the webhook must be turned off in order to delete it' }],
        },
      };
      callback({ response: errorResponse });
      return;
    }

    _.remove(this._getWebhooks('sagan---'), { id: webhookId });
    callback(null, { status: 204, statusText: statusText(204) });
  }

  update(attrs, callback, path, { webhookId }) {
    _.remove(this._getWebhooks('sagan---'), { id: webhookId });
    this._getWebhooks('sagan---').push(attrs);

    callback(null, { status: 204, statusText: statusText(204) });
  }

  _getWebhooks(orgId) {
    return this.getDatabase(orgId).webhooks;
  }

  getRoutes() {
    return bindCallbacks(
      {
        '/api/v1/webhooks': {
          GET: this.fetchAll,
          POST: this.add,
        },
        '/api/v1/webhooks/:webhookId': {
          DELETE: this.delete,
          PATCH: this.update,
        },
      },
      this
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/fake_backend_http/webhook_service.js